import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { AdminHeader } from 'src/app/shared/models/admin-header.model';
import { NativeSoilService } from '../../worksheet/services/native-soil/native-soil.service';
import { ActivatedRoute } from '@angular/router';
import { SampleRow } from 'src/app/shared/models/SampleRow.model';
import { WorksheetService } from '../../worksheet/services/worksheet.service';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';
import { PrecastService } from 'src/app/shared/services/precast.service';
export interface PrecastPivotRow {
  inHouseId: string;

  targetMc1?: string;
  targetWeight1?: number;
  actualWeight1?: string;

  targetMc2?: string;
  targetWeight2?: number;
  actualWeight2?: string;

  targetMc3?: string;
  targetWeight3?: number;
  actualWeight3?: string;

  targetMc4?: string;
  targetWeight4?: number;
  actualWeight4?: string;

  targetWeight5?: number;
  actualWeight5?: string;
}
@Component({
    selector: 'app-precast-print-table',
    templateUrl: './precast-print-table.component.html',
    styleUrls: ['./precast-print-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrecastPrintTableComponent {

  constructor(    
    private precastService: PrecastService,
    private worksheetService: WorksheetService,
    private route: ActivatedRoute){
  }

  private groupIdToIndex: { [key: string]: number } = {};

  asRecivedWorksheetsData: AdminHeader[] = [];
  moistureWorksheetsData: AdminHeader[] = [];
  nativeSoilWorksheetsData: AdminHeader[] = [];
  proctorWorksheetsData: AdminHeader[] = [];
  allResponseWorksheet: any;
  allWorksheetApiRes:any;
  @Output() allResNativeWorksheet = new EventEmitter<any>();

  receivedWorkSheet = [];
  moistureWorksheets = [];
  proctorWorksheets = [];
  workSheets = [];

  groupedRows: { groupId: string, rows: SampleRow[], showSeparator: boolean}[] = [];

  @Output() fetchAllHeader = new EventEmitter<{
    asRecivedWorksheets: AdminHeader[],
    moistureWorksheets: AdminHeader[],
    nativeSoilWorksheets: AdminHeader[],
    proctorWorksheets: AdminHeader[]
  }>();

  displayedColumns = [
    'inHouseId',

    'targetMc1',
    'targetWeight1',
    'actualWeight1',

    'targetMc2',
    'targetWeight2',
    'actualWeight2',

    'targetMc3',
    'targetWeight3',
    'actualWeight3',

    'targetMc4',
    'targetWeight4',
    'actualWeight4',

    'targetWeight5',
    'actualWeight5'
  ];

  dataSource: PrecastPivotRow[] = [];
  projectName: string = '';
  companyName: string = '';
  projectReference?: string;
  dueDate?: string;
  isRush?: boolean;

  ngOnInit(){
    document.body.classList.add('print-no-header');
    this.route.queryParams.subscribe(params => {
      const projectId = params['projectId'];
      this.getProject(projectId);
      this.getWorkSheets(projectId);
      this.getCompany(projectId);
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('print-no-header');
  }

  getWorkSheets(projectId: string): void {
    this.precastService.fetchWorksheetsWithMixDesignRowbyId(projectId).subscribe({
      next: (response: any) => {
        let initial = 1;
        this.workSheets = response;
        this.workSheets.forEach((worksheet: any) => {
          if (!worksheet.groupOrder) {
            initial += 1;
          }
        });

        this.dataSource = [];
        this.workSheets.forEach((worksheet : any) => {
          console.log(worksheet);
          const mcValues: number[] = [];
          let initialMoisture = this.calculateMoistureContent(worksheet.mixDesign);
          let highestWeight = worksheet.preCastWorkSheetTestResults.find((x: any) => x.testNumber === 1)?.weight;

          mcValues.push(initialMoisture);
          let currentMoisture = initialMoisture * 0.5;
          mcValues.push(currentMoisture);

          currentMoisture = currentMoisture * 0.5;
          mcValues.push(currentMoisture);

          currentMoisture = currentMoisture * 0.4;
          mcValues.push(currentMoisture);

          mcValues.push(0);
          this.dataSource.push({
            inHouseId: worksheet.inHouseId ?? '',
            
            targetMc1: mcValues[0].toFixed(2),
            targetWeight1: this.calculateTargetWeight(initialMoisture, mcValues[0], highestWeight),
            actualWeight1: '',

            targetMc2: mcValues[1].toFixed(2),
            targetWeight2: this.calculateTargetWeight(initialMoisture, mcValues[1], highestWeight),
            actualWeight2: '',

            targetMc3: mcValues[2].toFixed(2),
            targetWeight3: this.calculateTargetWeight(initialMoisture, mcValues[2], highestWeight),
            actualWeight3: '',

            targetMc4: mcValues[3].toFixed(2),
            targetWeight4: this.calculateTargetWeight(initialMoisture, mcValues[3], highestWeight),
            actualWeight4: '',
            
            targetWeight5: this.calculateTargetWeight(initialMoisture, mcValues[4], highestWeight),
            actualWeight5: ''
          });
        });
      },
      error: (err) => {
        console.error('Error fetching worksheets:', err);
      },
    });
  }

  calculateMoistureContent(mixDesign: any): number {
    const items = mixDesign?.items || [];

    const totalWater = items
      .filter((x: any) => x.materialType?.toLowerCase() === 'water')
      .reduce((sum: number, x: any) => sum + (Number(x.weight) || 0), 0);

    const totalWeight = items
      .filter((x: any) => x.materialType?.toLowerCase() !== 'add mixer')
      .reduce((sum: number, x: any) => sum + (Number(x.weight) || 0), 0);

    const dryWeight = totalWeight - totalWater;

    return dryWeight > 0
      ? Number(((totalWater / dryWeight) * 100).toFixed(2))
      : 0;
  }

  calculateTargetWeight(initialMoisture: number, currentMoisture: number, highestWeight: number): number {
    var targetWeight = (highestWeight * currentMoisture) / initialMoisture;
    return Math.round(targetWeight);
  }

  setDepth(elem: any): string {
    let depthRange = '';
    if (elem.depth !== null) {
      depthRange = `${elem.depth}`;
    }
    if (elem.endDepth) {
      if (elem.depth !== null && elem.endDepth === null) {
        depthRange = `${elem.depth}`;
      }
      if (elem.endDepth !== null && elem.depth !== null) {
        depthRange = `${elem.depth}-${elem.endDepth}`;
      }
    }
    return depthRange;
  }

  printTable() {
    window.print();
  }

  getRowColor(groupId: string): string {
    const index = this.groupIdToIndex[groupId];
    return index % 2 === 0 ? 'white-row' : 'gray-row';
  }

  getProject(projectId : string)
  {
    const projectResponse = this.worksheetService.fetchProjectById(projectId);
    projectResponse.subscribe(res=>{
      this.projectName = res.projectName;
      this.projectReference = res.referenceId;
      this.dueDate = res.dueDate ? DateTimeUtils.getLocalDateTimeFromUTCDate(res.dueDate, 'MM/dd/yyyy').toString() : '';
      this.isRush = res.rushTesting;
    });
  }

  getCompany(companyId: string)
  {
    const companyResponse = this.worksheetService.fetchCompanyById(companyId);
    companyResponse.subscribe((res: any)=>{
      this.companyName = res.company.name;
    })
  }

  shouldShowSeparator(group: any): boolean {
    const prevGroup = this.groupedRows[this.groupedRows.indexOf(group) - 1];
    const currentGroup = this.groupedRows[this.groupedRows.indexOf(group)];

    if (!prevGroup?.rows?.length || !currentGroup?.rows?.length) {
      return false;
    }
    var result = prevGroup.rows[0].nativeSoilSampleId !== currentGroup.rows[0].nativeSoilSampleId;
    return result;
  }
}
